module.exports = __webpack_public_path__ + "img/c00c2c2.png";